(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificates"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  const openBtn = document.querySelector('.open-popup');
  const popup = document.querySelector('.popup');

  if (openBtn && popup) {

    openBtn.addEventListener('click', function () {
      popup.style.display = 'block';
      document.body.classList.add('popup-open');
    });

    popup.addEventListener('click', function (event) {
      if (!event.target.closest('.popup-content-box')) {
        popup.style.display = 'none';
        document.body.classList.remove('popup-open');
      }
    });

  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifting_certificates"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  const openBtn = document.querySelector('.open-popup');
  const popup = document.querySelector('.popup');

  if (openBtn && popup) {

    openBtn.addEventListener('click', function () {
      popup.style.display = 'block';
      document.body.classList.add('popup-open');
    });

    popup.addEventListener('click', function (event) {
      if (!event.target.closest('.popup-content-box')) {
        popup.style.display = 'none';
        document.body.classList.remove('popup-open');
      }
    });

  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelector('.swiper.product-list')){
      new Swiper('.swiper.product-list', {
        slidesPerView: 'auto',
        spaceBetween: 8,
        cssMode: true,
        mousewheel: { forceToAxis: true },
        pagination: {
          el: document.querySelector('.swiper.product-list .swiper-pagination')
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1000: {
                slidesPerView: 4
            }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-blocks"] && !Shopify.designMode) return;
  try {
    
// document.addEventListener('DOMContentLoaded', function(){
//     if(document.querySelectorAll('.video-play-btn').length > 0){
//         document.querySelectorAll('.video-card').forEach(element => {
//             element.onclick = function(event){
//                 if(element.classList.contains('video-playing')){
//                     element.querySelector('video').pause();
//                     element.classList.remove('video-playing');
//                     element.querySelector('.video-play-btn').style.display = 'flex';
//                 }
//                 else{
//                     element.classList.add('video-playing');
//                     element.querySelector('video').play();
//                     element.querySelector('.video-play-btn').style.display = 'none';
//                 }
//             }
//         });
//     }
// });


document.addEventListener('DOMContentLoaded', () => {
  const videoCards = document.querySelectorAll('.video-card');

  if (!videoCards.length) return;

  videoCards.forEach((card) => {
    const video = card.querySelector('video');
    const btn = card.querySelector('.volume-btn');

    if (!video || !btn) return;

    const muteIcon = btn.querySelector('.icon-mute');
    const unmuteIcon = btn.querySelector('.icon-unmute');

    btn.addEventListener('click', () => {
      video.muted = !video.muted;

      if (muteIcon) muteIcon.classList.toggle('hidden', !video.muted);
      if (unmuteIcon) unmuteIcon.classList.toggle('hidden', video.muted);
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-feed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.video-btn-actions').forEach(function(elem){
      elem.onclick = function(event){
        event.preventDefault();
        let card = elem.closest('.video-block');
        let videoElement = card.getElementsByTagName('video')[0];
        if(card.classList.contains('sound-on')){
            videoElement.muted = true;
        }
        else{
            videoElement.muted = false;
        }
        elem.closest('.video-block').classList.toggle('sound-on');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
